'use client'

/* eslint-disable multiline-ternary */
/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable @typescript-eslint/no-floating-promises */
import React, { useState } from 'react'
import { getInitialDescription } from '@utils/utils'
import styles from './productAtfPageInfo.module.scss'

const ProductAtfPageMainInfo = ({ productAtfPageMainInfoData, isSemPage = false }) => {
  const heading = productAtfPageMainInfoData?.Content?.data?.attributes?.heading
  const description = productAtfPageMainInfoData?.Content?.data?.attributes?.description

  const [showFullDescription, setShowFullDescription] = useState(false)

  const toggleDescription = () => {
    setShowFullDescription(!showFullDescription)
  }

  if (!heading && !description) {
    return null
  }

  return (
    <div className={`${styles.productAtfPageInfoRootContainer} ${isSemPage && styles.semPageStyle}`}>
      <div className={styles.productAtfPageInfoMainContainer}>
        <h1 className={styles.headingAtfPage}>{heading}</h1>
        <div className={styles.descriptionContainer}>
          <p className={`${styles.descriptionAtfPage} ${showFullDescription ? styles.showFull : ''}`}>{description}</p>
          <span className={styles.shortenedDescriptionAtfPage}>
            <div className={styles.showDesktop}>
              {!showFullDescription ? getInitialDescription(description, 36) : null}...
              <button type="button" onClick={toggleDescription} className={styles.readMoreShowLessButton}>
                {!showFullDescription ? 'Read more' : 'Show less'}
              </button>
            </div>
            <div className={styles.showMweb}>
              {!showFullDescription ? getInitialDescription(description, 13) : null}...
              <button type="button" onClick={toggleDescription} className={styles.readMoreShowLessButton}>
                {!showFullDescription ? 'Read more' : 'Show less'}
              </button>
            </div>
          </span>
        </div>
      </div>
    </div>
  )
}

export default ProductAtfPageMainInfo
